import { get } from '../ApiService';
import { ServiceContainer } from '../ServiceContainer/ServiceContainer';

import { Account, ClientType, ConstructionType, EnergyLabel, LoanForm, NHG } from '../../Enum/Filters/';
import { InterestByFixedPeriod } from '../../Interface/Response/Interest/InterestByFixedPeriod';
import { InterestByMarketValue } from '../../Interface/Response/Interest/InterestByMarketValue';
import { InterestPerProduct } from '../../Interface/Response/Interest/InterestPerProduct';
import { Label } from '../../Interface/Response/Interest/Label';
import { ModificationLoanForm } from '../../Interface/Response/Interest/ModificationLoanForm';
import { AcceptationGuideData } from '../../Interface/Response/Interest/AcceptationGuideData';
import { Period } from '../../Interface/Interest/Period';
import { getIdentifier } from '../../Helpers/Interest/PeriodHelper';

export const getInterestData = <T>(uri: string): Promise<T> => {
    const { storeGateway } = ServiceContainer;
    return get<T>(uri, storeGateway.getState().auth.token);
};

export const getLabels = (): Promise<Label[]> => getInterestData<Label[]>('v1/filter/label');

export const getModificationLoanForms = (finDataCode: string): Promise<ModificationLoanForm[]> =>
    getInterestData<ModificationLoanForm[]>(`v1/filter/loanform/${finDataCode}`);

export const getInterestsPerProduct = (
    label: Label,
    loanForm: string,
    constructionType: ConstructionType,
): Promise<InterestPerProduct> =>
    getInterestData<InterestPerProduct>(`v1/filter/rente/${label.findataCode}/${loanForm}/${constructionType}`);

export const getInterestsByMarketValue = (
    loanForm: LoanForm,
    periodInMonths: string,
    energyLabel: EnergyLabel,
    constructionType: ConstructionType,
    nhg: NHG,
    clientType: ClientType,
    account: Account,
): Promise<InterestByMarketValue> =>
    getInterestData<InterestByMarketValue>(
        `v1/filter/ltv/${loanForm}/${periodInMonths}/${encodeURIComponent(
            energyLabel
        )}/${constructionType}/${nhg}/${clientType}/${account}`,
    );

export const getInterestsByFixedPeriod = (
    loanForm: LoanForm,
    periodInMonths: Period[],
    energyLabel: EnergyLabel,
    constructionType: ConstructionType,
    nhg: NHG,
    riskCategory: string,
    clientType: ClientType,
    account: Account,
): Promise<InterestByFixedPeriod> => {
    const periods = periodInMonths.map(period => getIdentifier(period));

    return getInterestData<InterestByFixedPeriod>(
        `v1/filter/rvp/${periods.join()}/${riskCategory}/${loanForm}/${encodeURIComponent(
            energyLabel,
        )}/${constructionType}/${nhg}/${clientType}/${account}`,
    );
}

export const getAcceptationGuideData = (): Promise<AcceptationGuideData[]> =>
    getInterestData<AcceptationGuideData[]>('v1/filter/product-properties/acceptation-guide-data');

export const getPeriodsInfo = (): Promise<Period[]> => getInterestData<Period[]>('v1/filter/period-info');
